// 英文译文 · 产品库 / 库存台账 / 外部平台 · key = 代码里的中文原文,一字不差
export default {
  // ── 产品库 · 外壳 ──
  "本公司产品档案 · 编号主表 · xlsx 导入 · 分类树": "Company product records · Product Master · xlsx import · Category tree",
  "本公司产品": "Company Products",
  "编号主表": "Product Master",
  "xlsx 导入": "xlsx Import",
  "分类树": "Category Tree",
  // ── 产品分类 ──
  "code / name 必填": "code / name are required",
  "产品分类树": "Product Category Tree",
  "新建分类": "New Category",
  "编辑分类": "Edit Category",
  "父级 ID": "Parent ID",
  "父级": "Parent",
  "排序": "Sort Order",
  "小写字母/数字/连字符": "Lowercase letters / digits / hyphens",
  "code 建成后不可改(引用一致性)": "code can't be changed after creation (keeps references consistent)",
  "根分类留空": "Leave empty for a top-level category",
  // ── 本公司产品 ──
  "确认 停用 {code}?": "Disable {code}?",
  "确认 启用 {code}?": "Enable {code}?",
  "本公司产品库": "Company Products",
  "搜编号/名称/简称": "Search code / name / short name",
  "名称 / 简称": "Name / Short name",
  "长×宽×高(cm)": "L × W × H (cm)",
  "待审": "Pending",
  "启用状态": "Enabled status",
  "未启用": "Not enabled",
  "主表: {name}": "Master: {name}",
  "售价": "Sale Price",
  "主表状态": "Master Status",
  "编辑本公司档案": "Edit Company Product Record",
  "基础/售价": "Basics / Pricing",
  "本地名": "Local Name",
  "售价 CNY": "Sale Price CNY",
  "售价 HKD": "Sale Price HKD",
  "售价 USD": "Sale Price USD",
  "售价 EUR": "Sale Price EUR",
  "建议进价": "Suggested Purchase Price",
  "最高进价": "Max Purchase Price",
  "最低售价": "Min Sale Price",
  "含税": "Tax Included",
  "采购提前期(天)": "Purchase Lead Time (days)",
  "包装/库存": "Packaging / Stock",
  "外包单位": "Outer Pack Unit",
  "箱/托/袋": "carton / pallet / bag",
  "外包数量": "Outer Pack Qty",
  "内盒单位": "Inner Pack Unit",
  "内盒数量": "Inner Pack Qty",
  "采购 MOQ": "Purchase MOQ",
  "安全库存": "Safety Stock",
  "下限告警": "Low Stock Alert",
  "上限告警": "High Stock Alert",
  "报关": "Customs",
  "申报名(中)": "Declared Name (CN)",
  "申报名(英)": "Declared Name (EN)",
  "申报价 USD": "Declared Value USD",
  "申报重量(g)": "Declared Weight (g)",
  "含电池": "Contains Battery",
  "扩展/备注": "Extra / Notes",
  "本地描述": "Local Description",
  "自定义文本 1": "Custom Text 1",
  "自定义文本 2": "Custom Text 2",
  "自定义文本 3": "Custom Text 3",
  "自定义数值 1": "Custom Number 1",
  "自定义数值 2": "Custom Number 2",
  // ── 产品主表 ──
  "确认归档 {code}?归档后从常规列表消失(需选状态=archived 才能看到)": "Archive {code}? Archived items disappear from the normal list (filter by status = archived to see them)",
  "产品主表": "Product Master",
  "搜编号/名称": "Search code / name",
  "去产品库": "Go to Products",
  "中文名": "Chinese Name",
  "英文名": "English Name",
  "规格": "Specification",
  "品牌": "Brand",
  "最近导入": "Last Imported",
  "首次导入": "First Imported",
  // ── 产品主表详情 ──
  "没有变化": "No changes",
  "确认归档 {code}?": "Archive {code}?",
  "返回产品库": "Back to Products",
  "手动编辑": "Edit Manually",
  "基本信息": "Basic Info",
  "产品类型": "Product Type",
  "条码": "Barcode",
  "尺寸(cm)": "Dimensions (cm)",
  "净 {net} · 毛 {gross} · 体积重 {vol}": "Net {net} · Gross {gross} · Volumetric {vol}",
  "{n} 天": "{n} days",
  "不限": "Unlimited",
  "本公司档案": "Company Record",
  "(用主表名)": "(uses master name)",
  "去【本公司产品库】编辑": "Edit in \"Company Products\"",
  "本公司无档案(通常导入时自动建 · 检查数据)": "No company record (normally created automatically on import · check the data)",
  "变更历史 ({n})": "Change History ({n})",
  "(空)": "(empty)",
  "无变更记录": "No change history",
  "附件 ({n})": "Attachments ({n})",
  "无附件(上传功能待建)": "No attachments (upload not available yet)",
  "文件名": "File Name",
  "上传人": "Uploaded By",
  "上传时间": "Uploaded At",
  "链接": "Link",
  "选单位": "Select unit",
  "实体": "Physical",
  "虚拟": "Virtual",
  "组合": "Bundle",
  "长(cm)": "Length (cm)",
  "宽(cm)": "Width (cm)",
  "高(cm)": "Height (cm)",
  "净重(g)": "Net Weight (g)",
  "毛重(g)": "Gross Weight (g)",
  // ── 产品编号 xlsx 导入 ──
  "先选文件": "Select a file first",
  "解析失败": "Failed to parse",
  "确认导入 {n} 行产品编号?": "Import {n} rows of product codes?",
  "确认导入": "Confirm Import",
  "导入完成 · 新增 {inserted} · 更新 {updated} · 跳过 {skipped}": "Import complete · {inserted} new · {updated} updated · {skipped} skipped",
  "导入失败": "Import failed",
  "确认把 {n} 个\"可能停用\"SKU 标为 disabled?": "Mark {n} \"possibly discontinued\" SKUs as disabled?",
  "已标 {n} 条为 disabled": "Marked {n} as disabled",
  "产品编号 xlsx 导入": "Product Code xlsx Import",
  "产品档案 xlsx · 支持多分片一起上传(会合并解析)· 自动 upsert:新增 or 更新差异 or 跳过全同 · 差集报告\"可能停用\"SKU": "Product xlsx files · Several parts can be uploaded together (parsed as one) · Automatic upsert: insert new, update changed, skip identical · SKUs missing since the last import are reported as \"possibly discontinued\"",
  "选中 {n} 个文件": "{n} file(s) selected",
  "解析预览": "Parse Preview",
  "执行导入": "Run Import",
  "总行数": "Total Rows",
  "识别到的列": "Recognized Columns",
  "缺失必需列": "Missing Required Columns",
  "必需列齐全": "All required columns present",
  "前 20 行样本": "Sample (first 20 rows)",
  "导入结果": "Import Result",
  "新增": "New",
  "更新": "Updated",
  "跳过": "Skipped",
  "可能停用": "Possibly Discontinued",
  "上次导入有 · 本次没出现的 SKU({n})": "SKUs in the last import but missing from this one ({n})",
  "一键标为 disabled": "Mark All as disabled",
  "最近导入批次": "Recent Import Batches",
  "行数": "Rows",
  // ── 库存台账 · 外壳 ──
  "每仓 × 每 SKU 快照 · 流水只 append · 智邦为 baseline 权威源": "Snapshot per warehouse × SKU · Transactions are append-only · Zhibang is the authoritative baseline",
  "仓库管理": "Warehouses",
  "流水": "Transactions",
  // ── 库存台账 ──
  "qty_delta 不能为 0": "qty_delta cannot be 0",
  "调整已提交": "Adjustment submitted",
  "安全库存已更新": "Safety stock updated",
  "请选择目标仓": "Please select a target warehouse",
  "请粘贴 CSV(每行: product_master_id,qty[,unit_cost])": "Please paste CSV (one row per line: product_master_id,qty[,unit_cost])",
  "第 {n} 行格式错 · 至少 product_master_id,qty": "Line {n} is malformed · needs at least product_master_id,qty",
  "第 {n} 行 pmId/qty 非数字": "Line {n}: pmId/qty is not a number",
  "期初已写入 {n} 行": "Opening stock written · {n} rows",
  "库存 SKU 数": "SKUs in Stock",
  "SKU 数(产品库)": "SKUs (product list)",
  "有库存记录 {n}": "{n} with stock records",
  "还没有库存记录(没录期初、没进出过)": "No stock record yet (no opening stock, no movements)",
  "总件数": "Total Units",
  "低于安全库存 SKU 数": "SKUs Below Safety Stock",
  "需补货": "Restock needed",
  "仓库数(active)": "Warehouses (active)",
  "全部仓": "All warehouses",
  "搜产品编码/名称": "Search product code / name",
  "只看低于安全库存": "Below safety stock only",
  "期初库存": "Opening Stock",
  "产品编码": "Product Code",
  "仓库": "Warehouse",
  "在库": "On Hand",
  "改": "Edit",
  "最近变动": "Last Movement",
  "调整": "Adjustment",
  "看流水": "View Transactions",
  "库存调整(admin)": "Stock Adjustment (admin)",
  "当前在库 {n}": "Currently on hand: {n}",
  "调整量": "Adjustment Qty",
  "正数=入库 · 负数=出库(限 admin)": "Positive = inbound · Negative = outbound (admin only)",
  "单价(可选)": "Unit Cost (optional)",
  "调整原因(建议填 · 便于审计)": "Reason for the adjustment (recommended · helps auditing)",
  "期初库存 · 批量导入": "Opening Stock · Bulk Import",
  "期初仅限首次导入(该 SKU × 仓 若已有流水会被拒)· 写 opening 流水": "Opening stock is for the first import only (rejected if the SKU × warehouse already has transactions) · writes an opening transaction",
  "目标仓": "Target Warehouse",
  "行": "Rows",
  "每行 CSV: product_master_id,qty[,unit_cost]": "One CSV row per line: product_master_id,qty[,unit_cost]",
  "例:": "Example:",
  "支持逗号或 Tab 分隔 · 空行忽略": "Comma or Tab separated · Blank lines are ignored",
  "写入期初": "Write Opening Stock",
  "最近 20 条流水": "Last 20 Transactions",
  "变动": "Change",
  "之后": "After",
  // ── 仓库管理 ──
  "warehouse_code 必填": "warehouse_code is required",
  "warehouse_name 必填": "warehouse_name is required",
  "将 {code} · {name} 设为默认仓?": "Set {code} · {name} as the default warehouse?",
  "(该 tenant 原默认仓会同时被取消 · atomic)": "(the company's current default warehouse is unset at the same time · atomic)",
  "设为默认仓": "Set as Default Warehouse",
  "默认仓已切换": "Default warehouse switched",
  "归档 {code} · {name} ?": "Archive {code} · {name}?",
  "(有 qty_on_hand>0 的库存则拒绝)": "(refused if any stock has qty_on_hand > 0)",
  "归档仓库": "Archive Warehouse",
  "新建仓库": "New Warehouse",
  "编辑仓库": "Edit Warehouse",
  "编码": "Code",
  "编码不可改": "Code can't be changed",
  "智邦 wh_id": "Zhibang wh_id",
  "未绑定": "Not linked",
  "智邦路径": "Zhibang Path",
  "设为默认": "Set Default",
  "主仓 / 副仓 / ...": "Main Warehouse / Secondary Warehouse / ...",
  "智邦 wh_id 空表示未绑定智邦 · 该仓不参与智邦对齐/回填": "Empty Zhibang wh_id = not linked to Zhibang · this warehouse is excluded from Zhibang alignment / backfill",
  "一级分类->仓库名": "Top-level category->Warehouse name",
  "同一 tenant 至多 1 个默认仓 · 保存时 atomic 切换": "At most 1 default warehouse per company · switched atomically on save",
  // ── 库存流水 ──
  "入库": "Inbound",
  "出库": "Outbound",
  "调拨入": "Transfer In",
  "调拨出": "Transfer Out",
  "期初": "Opening",
  "盘存基线": "Stock Baseline",
  "成本调整": "Cost Adjustment",
  "发货单": "Shipment",
  "手工调整": "Manual Adjustment",
  "外部同步": "External Sync",
  "盘点": "Stock Count",
  "库存流水": "Inventory Transactions",
  "流水类型(多选)": "Transaction type (multi-select)",
  "流水详情": "Transaction Details",
  "之后 qty": "Qty After",
  "批次": "Batch",
  // ── 外部平台 · 同步节奏 / 状态 ──
  "仅手动(不自动拉)": "Manual only (no auto sync)",
  "每 {n} 分钟": "Every {n} minutes",
  "每小时": "Hourly",
  "每 {n} 小时": "Every {n} hours",
  "每天": "Daily",
  "仅手动": "Manual only",
  "每 {n} 分": "Every {n} min",
  "成功": "Success",
  "部分成功": "Partial success",
  "授权失败": "Auth failed",
  "网络失败": "Network error",
  "进行中": "Running",
  // ── 外部平台 · 提示 ──
  "加载 adapter 注册表失败: {msg}": "Failed to load adapter registry: {msg}",
  "加载失败: {msg}": "Failed to load: {msg}",
  "加载详情失败: {msg}": "Failed to load details: {msg}",
  "连接正常": "Connection OK",
  "连接失败": "Connection failed",
  "名称必填": "Name is required",
  "系统对接(一件代发中间件等)在下方单独一块": "System integrations (dropship middleware etc.) are in a separate section below",
  "系统对接": "System integrations",
  "不是店铺 · 不拉订单 · 比如一件代发中间件:发货单按平台单号来这里取运单号": "Not stores · no order pull · e.g. the dropship middleware: shipments fetch their waybill from it by platform order number",
  "新建对接": "New integration",
  "发货单取运单号": "Waybills for shipments",
  "最近测试": "Last test",
  "还没有系统对接 · 发货公司要自动取运单号时,点【➕ 新建对接】加一件代发中间件": "No system integrations yet · to fetch waybills automatically, click [➕ New integration] and add the dropship middleware",
  "编辑系统对接": "Edit integration",
  "新建系统对接": "New integration",
  "一件代发中间件": "Dropship middleware",
  "不拉单 · 只查运单号": "No order pull · waybill lookup only",
  "测试": "Tested",
  "还没测试": "Not tested yet",
  "测试连接": "Test connection",
  "一件代发中间件不拉订单 · 发货单按销售单的平台单号来这里取运单号(建发货单时自动取,发货单上也能点【查运单号】)": "The dropship middleware does not pull orders · shipments fetch their waybill from it by the sales order's platform order number (automatically when a shipment is created, or via [Find waybill] on the shipment)",
  "失败: {msg}": "Failed: {msg}",
  "测试失败: {msg}": "Test failed: {msg}",
  "请选平台": "Please select a platform",
  "店铺名必填": "Store name is required",
  "账号标识必填": "Account identifier is required",
  "保存失败: {msg}": "Save failed: {msg}",
  "拉单完成 · 拉到 {fetched} · 新增 {created} · 状态更新 {updated} · 无变化 {duplicate}": "Order sync done · fetched {fetched} · new {created} · status updated {updated} · unchanged {duplicate}",
  "已过滤 {n}": "filtered {n}",
  "同步退款 {n} 笔": "{n} refunds synced",
  "拉单失败: {msg}": "Order sync failed: {msg}",
  "确认删除店铺 {name}?若有 SO 关联会被拒绝。": "Delete store {name}? This is refused if any SO is linked to it.",
  "删除店铺": "Delete Store",
  "删除失败: {msg}": "Delete failed: {msg}",
  // ── 外部平台 · 页面 ──
  "Shopify / Etsy / Amazon 等平台账号 · 拉单同步节奏 · 授权状态 · 未来加平台不改前端结构": "Shopify / Etsy / Amazon and other platform accounts · Order sync schedule · Authorization status · New platforms plug in without frontend changes",
  "新建店铺": "New Store",
  "编辑店铺": "Edit Store",
  "自动拉单已开启": "Auto order sync is on",
  "自动拉单已关闭": "Auto order sync is off",
  "系统每": "The system scans every",
  "分钟扫一次": "minutes",
  "具体某家店拉不拉,看它自己的「同步节奏」设置(设成「仅手动」的店不会自动拉)": "Whether a store is synced depends on its own \"Sync Schedule\" setting (stores set to \"Manual only\" are never synced automatically)",
  "需在 .env 里设": "In .env, set",
  "并重启服务": "and restart the service",
  "数据流约定": "Data Flow Conventions",
  "平台单进【销售订单】· 买家个人信息(姓名/邮箱/电话/地址)冗余在订单里": "Platform orders go into \"Sales Orders\" · Buyer personal info (name / email / phone / address) is stored on the order",
  "不进【客户库】": "not in \"Customers\"",
  "(客户库只放 B2B)": " (Customers holds B2B only)",
  "平台收款走【收付款管理 · 平台结算】类目": "Platform receipts go under \"Receipts & Payments · Platform Payout\"",
  "店铺列表": "Stores",
  "全部平台": "All platforms",
  "共 {n} 家": "{n} total",
  "店铺名": "Store Name",
  "账号 / 域名": "Account / Domain",
  "发货方": "Fulfilled By",
  "外部系统(中间件)发货 · ERP 只记账,不能派采购/建发货": "Fulfilled by an external system (middleware) · ERP only records it; no POs / shipments can be created",
  "外部系统": "External System",
  "同步节奏": "Sync Schedule",
  "回看 {n} 天": "Look back {n} days",
  "最近同步": "Last Sync",
  "从未": "Never",
  "拉单": "Sync Orders",
  "还没接入店铺 · 点右上角【➕ 新建店铺】开始": "No stores connected yet · Click \"➕ New Store\" at the top right to get started",
  "最近拉单日志(跨平台)": "Recent Order Sync Logs (all platforms)",
  "店铺": "Store",
  "(全量)": "(all stores)",
  "触发方式": "Triggered By",
  "拉到": "Fetched",
  "已在 ERP 的订单,平台上被取消 / 退款 / 发货后同步过来的": "Orders already in the ERP that were cancelled / refunded / shipped on the platform and synced back",
  "状态更新": "Status Updated",
  "没进 ERP 的单里:平台已取消、未付款、未发货就全额退款、下单早于拉单窗口、只有小费等非实物行 —— 不会落成销售订单": "Orders not brought into the ERP: cancelled on the platform, unpaid, fully refunded before shipping, placed before the sync window, or with only non-physical lines such as tips — these don't become sales orders",
  "已过滤": "Filtered",
  "结果": "Result",
  "账号标识": "Account Identifier",
  "授权方式": "Auth Method",
  "凭据": "Credentials",
  "同步": "Sync",
  "首次拉单窗口(天)": "Initial Sync Window (days)",
  "ERP 发货": "ERP fulfills",
  "外部系统发货(ERP 只记账)": "External system fulfills (ERP only records)",
  "同一个店铺已由中间件等其他系统发货时选「外部系统」:该店订单在 ERP 里不能派采购单、建发货单(防止重复扣库存),平台显示已发货后销售单自动转「已发货」。": "Choose \"External System\" when this store is already fulfilled by another system such as the middleware: its orders can't get purchase orders or shipments in the ERP (prevents double stock deduction), and the sales order switches to \"Shipped\" automatically once the platform shows it as shipped.",
  "结算到账账户": "Payout Account",
  "不设 = 只记打款,不生成收款单": "Not set = record payouts only, no receipt created",
  "Shopify 打款到哪个银行账户 · 设了以后每次打款自动在「收付款管理 → 平台结算」生成一笔收款单。": "The bank account Shopify pays out to · Once set, every payout automatically creates a receipt under \"Receipts & Payments → Platform Payout\".",
  "香港店一般是港币账户(订单是 EUR / USD,平台换汇后打款)。没有账户先去「收付款管理 → 银行账户」建一个。": "Hong Kong stores usually use an HKD account (orders are in EUR / USD; the platform converts before paying out). If there's no account yet, create one under \"Receipts & Payments → Bank Accounts\" first.",
  "测试连通": "Test Connection",
  // ── 外部平台 · 后端 adapter registry 返回的中文(显示时 tr())──
  "Shopify 域名": "Shopify Domain",
  "Shopify 后台 → Apps → Develop apps → API credentials": "Shopify admin → Apps → Develop apps → API credentials",
  // 2026-09-29 产品库导入模板 · 产品图片 · 来货价批量通过
  "产品图片": "Product images",
  "{n} 张(按行对应产品,存为产品主图)": "{n} (matched to products by row, saved as main image)",
  "来货价": "Supply price",
  "「{col}」列 {n} 个产品有价": "Column \"{col}\": {n} products have a price",
  "表里没有来货价": "No supply price in the file",
  "{n} 行缺产品编号或名称,导入时会跳过并记为错误 · 要导的话先在表里补上": "{n} rows are missing the product code or name and will be skipped as errors · fill them in the file to import them",
  "第 {row} 行": "Row {row}",
  "(无编号)": "(no code)",
  "(无名称)": "(no name)",
  "来货价 {v}": "supply price {v}",
  "有图片": "has image",
  "来货价导入到供应商": "Import supply prices for supplier",
  "不导来货价": "Don't import supply prices",
  "导成「待审批」,由另一位管理员在【供应商库 → 来货价】批量通过后生效;同价的不会重复建": "Imported as \"Pending review\"; they take effect after another admin approves them in bulk under Suppliers → Supply Prices. Identical prices are not duplicated.",
  "图片": "Image",
  "待审批来货价": "Supply prices pending review",
  "来货价同价跳过": "Same prices skipped",
  "图片已更新": "Image updated",
  "删除这个产品的图片?": "Delete this product's image?",
  "删除图片": "Delete image",
  "暂无图片": "No image",
  "换图片": "Replace image",
  "上传图片": "Upload image",
  "没有可以通过的来货价": "No supply prices you can approve",
  "确认通过 {n} 条来货价?通过后立即生效,同一供应商同一产品原来的生效价会被替代。": "Approve {n} supply prices? They take effect immediately and replace any current price for the same supplier and product.",
  "批量通过": "Bulk approve",
  "通过 {ok} 条 · {n} 条没通过:{reason}": "Approved {ok} · {n} not approved: {reason}",
  "已通过 {n} 条": "Approved {n}",
  "通过勾选的({n})": "Approve selected ({n})",
  "全部通过(我能审的)": "Approve all (that I can review)",
  "订单行补上匹配": "Order lines matched",
  "这一页没有你能审的:自己提交的要由别人复核,见「操作」列": "Nothing on this page you can review: items you submitted must be reviewed by someone else (see Actions)",
  "产品名称": "Product name",
  "规格 / 型号": "Spec / Model",
  "长": "Length",
  "宽": "Width",
  "高": "Height",
  "运单号回传平台 {n} 张": "Tracking sent to platform for {n} orders",
  "亚马逊:FBA 单只记账、不推下游;自发货单推到发货公司,在「收发货管理」出面单,发货后运单号自动回传亚马逊 → 下面「发货方」选「ERP 发货」(没有买家地址也照常推下去,包裹标「缺收货地址」)": "Amazon: FBA orders are recorded only, not pushed downstream; merchant-fulfilled orders are pushed to the shipping company and labelled in \"Shipping\", and tracking is sent back to Amazon automatically → set \"Shipper\" below to \"ERP\" (orders without the buyer's address are still pushed; the parcel is tagged \"missing address\")",
  "填平台 SKU 并选择产品": "Enter the platform SKU and select a product",
  "删掉对照 {alias} → {code}?已经匹配上的订单行不受影响,以后拉的单不再自动匹配。": "Delete mapping {alias} → {code}? Already matched order lines are unaffected; future orders will no longer match automatically.",
  "平台上的 SKU 和产品库编号对不上时在这里对照(比如亚马逊 listing 的 SKU)": "Map platform SKUs that differ from product codes here (e.g. Amazon listing SKUs)",
  "平台 SKU 对照": "Platform SKU mapping",
  "平台上的 SKU 和产品库编号对不上时(亚马逊 listing 的 SKU 建了就改不了)在这里对照一次:以后拉进来的单自动匹配,已有订单里这个 SKU 的行也马上补上。": "When a platform SKU differs from the product code (Amazon listing SKUs can't be changed), map it here once: future orders match automatically and existing order lines with this SKU are matched right away.",
  "平台 SKU,如 CK-US-FBM-B0CJLJF5WH": "Platform SKU, e.g. CK-US-FBM-B0CJLJF5WH",
  "备注(可不填)": "Note (optional)",
  "搜平台 SKU / 编号 / 名称": "Search platform SKU / code / name",
  "平台 SKU": "Platform SKU",
  // 2026-10-10 Etsy 店铺(Make 推单进 ERP)
  "已复制": "Copied",
  "浏览器不让复制 · 请手动选中复制": "The browser blocked copying · please select and copy manually",
  "重置「{name}」的收单密钥?旧密钥立即失效,Make 里要换成新的,否则推不进来。":
    "Reset the intake key of \"{name}\"? The old key stops working immediately; update it in Make or orders will be rejected.",
  "重置密钥": "Reset key",
  "同步完成 · 转给中间件 {relayed} 单(失败 {failed})· 查发货 {checked} 单 · 新标已发货 {shipped} 单":
    "Synced · {relayed} orders sent to middleware ({failed} failed) · {checked} checked for shipping · {shipped} newly shipped",
  "Make 推单 · 每 10 分钟回填发货": "Pushed by Make · shipping synced every 10 min",
  "立即同步": "Sync now",
  "Etsy 订单由 Make 推进 ERP:保存后会生成这个店铺专属的收单密钥(只显示一次),填进 Make 对应店铺的场景。店铺建在哪家公司,订单就进哪家公司;实物由一件代发中间件发货,ERP 自动回填已发货。":
    "Etsy orders are pushed into the ERP by Make: saving generates an intake key for this shop (shown once) to put in the shop's Make scenario. Orders go to the company the shop is created under; goods are shipped by the dropship middleware and the ERP marks them shipped automatically.",
  "「{name}」的收单密钥": "Intake key for \"{name}\"",
  "密钥只显示这一次,关掉就看不到了(库里只存加密指纹)。丢了就点「重置密钥」再生成一个。":
    "The key is shown only once (only a fingerprint is stored). If you lose it, click \"Reset key\" to generate a new one.",
  "收单密钥": "Intake key",
  "请求头": "Header",
  "推单": "Push orders",
  "连通测试": "Connection test",
  "请求体和返回格式跟以前推一件代发中间件的一样,Make 里只要换网址和密钥。":
    "Request and response formats are the same as when pushing to the dropship middleware; in Make just change the URL and key.",
  "我已保存好": "I've saved it",
    // 2026-10-19 出纳系统对接
  "重置「{name}」的 API-Key?旧 Key 立即失效,出纳系统里要换成新的,否则调不通。": "Reset the API key of \"{name}\"? The old key stops working immediately; update the cashier system with the new one or its calls will fail.",
  "出纳拉待付 / 待收,付完回写核销": "Cashier pulls payables / receivables and writes back payments for write-off",
  "IP 白名单:{ips}": "IP allowlist: {ips}",
  "最近调用": "Last call",
  "出纳还没调过": "Cashier hasn't called yet",
  "还没有系统对接 · 发货公司要自动取运单号时,点【➕ 新建对接】加一件代发中间件;要接出纳系统就加「出纳系统」": "No integrations yet · to fetch tracking numbers automatically, click [➕ New integration] and add the dropship middleware; to connect a cashier system, add \"Cashier system\"",
  "出纳系统:保存后生成本公司专属的 API-Key(只显示一次),连同对接文档发给出纳开发。Key 只能看到、只能改本公司的单据;建议填上出纳服务器的出口 IP。": "Cashier system: saving generates an API key for this company only (shown once); send it with the integration doc to the cashier developers. The key can only see and change this company's documents; we recommend entering the cashier server's outbound IP.",
  "「{name}」的 API-Key": "API key of \"{name}\"",
  "接口地址": "API base URL",
  "Key 请用加密方式单独发给出纳开发(别贴群)· 接口说明见《跨境ERP-出纳系统对接文档》。": "Send the key to the cashier developers separately over an encrypted channel (never in a group chat) · see the ERP–Cashier integration doc for the API.",
  "可回写": "Write-back on",
  "只读": "Read-only",
  "改为只读": "Make read-only",
  "开启回写": "Enable write-back",
  "开启后,出纳系统可以把「{name}」的付款单 / 费用申请记为已付、收款单记为已收(会核销发票)。确定已经联调通过?": "Once enabled, the cashier system can mark \"{name}\" payments / expense requests as paid and receipts as received (invoices get written off). Has integration testing passed?",
  "改为只读后,出纳系统只能查,回写会被拒绝。": "When read-only, the cashier system can only query; write-backs are rejected.",
  "已开启回写": "Write-back enabled",
  "已改为只读": "Now read-only",
} as Record<string, string>;
